<template>
    <div style="min-height: 100vh" class="mb-16">
        <div class="mb-6">
            <div class="title py-3 px-4 title-div">
                <p class="caption mb-0">
                    <a href="#/" class="grey--text text--lighten-2">Home / </a><a class="grey--text text--lighten-2">{{$route.params.category}}</a>
                </p>
                {{ $route.params.contentType === 'Attorney General' ? contentItem[0].Title : $route.params.contentType }}{{$route.params.contentType === "Why Join AGO" ? '?' : ''}}
            </div>
            <v-progress-linear
            v-if="loadingPage"
            indeterminate
            color="primary"
            ></v-progress-linear>
        </div>
        <v-row class="px-4">
            <v-col md="3" class="pl-0 hidden-sm-and-down">
                <div class="">
                <div
                v-for="(value, key) in navItems"
                :key="key"
                >
                    <v-list-group
                    dense
                    class="elevation-0"
                    :value="$route.params.category === key ? true : false"
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title class="px-0">{{key}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                        v-for="n in value"
                        :key="n"
                        @click="() => {}"
                        link
                        :href="n === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' :  `#/${key}/${n}`"
                        >
                            <v-list-item-title class="px-0 font-weight-light" :class="$route.params.contentType === n ? 'info--text' : ''">{{n === "Why Join AGO" ? n + '?' : n}}</v-list-item-title>
                            <v-divider></v-divider>
                        </v-list-item>
                    </v-list-group>
                    <v-divider></v-divider>
                </div>
                </div>
            </v-col>
            <v-col cols="11" sm="11" md="8" id="printdiv">
                <div v-if="!loadingPage">
                    <p class="display-1 primary--text mb-10">{{ $route.params.contentType === 'Attorney General' ? contentItem[0].Title : $route.params.contentType }}{{$route.params.contentType === "Why Join AGO" ? '?' : ''}} </p>
                    <!-- <p class="display-1 primary--text mb-10" style="font-family: 'Mv Eamaan XP' !important;">{{agProfile ? $route.params.contentType : getTitle($route.params.contentType)}} <a v-if="agProfile" href="https://twitter.com/ibriffath?ref_src=twsrc%5Etfw" class="twitter-follow-button" data-size="large" data-show-screen-name="false" data-show-count="false"><v-btn :dark="true" style="border-radius: 20px;" x-small color="#1d9cf0" fab :elevation="0"><v-icon>mdi-twitter</v-icon></v-btn></a></p> -->
                    
                    <div v-if="contentItem.length <= 1 && contentItem.length > 0 && $route.params.contentType !== 'Organization Structure'  && $route.params.contentType !== 'Constitution' && $route.params.contentType !== 'Meet our Interns' && $route.params.contentType !== 'Contact Us' && !$route.query.page" >
                        <single-content :contents="contentItem" v-if="!agProfile && $route.params.contentType !== 'Attorney General'"></single-content>
                        <ag-profile :contents="contentItem" v-if="$route.params.contentType === 'Attorney General'"></ag-profile>
                    </div>
                    <div v-else-if="(contentItem.length > 1 || ( contentItem.length == 1 &&  $route.query.page > 1)) && $route.params.contentType !== 'Senior Management' &&  $route.params.contentType !== 'Former Attorneys General' &&  $route.params.contentType !== 'Meet our Colleagues' && $route.params.contentType !== 'Meet our Interns' && $route.params.contentType !== 'Visits'">
                        <item-list :contents="contentItem"></item-list>
                    </div>
                    <div v-else-if="$route.params.contentType === 'Meet our Colleagues' || $route.params.contentType === 'Meet our Interns'">
                        <colleagues :contents="contentItem"></colleagues>
                    </div>
                    <div v-else-if="$route.params.contentType === 'Visits'">
                        <visits :totalRows="totalRows" :page="page" :numberOfPages="numberOfPages" :contents="contentItem"></visits>
                    </div>
                    <div v-else-if="$route.params.contentType === 'Former Attorneys General'">
                        <former-attorneys :contents="contentItem"></former-attorneys>
                    </div>
                    <div v-else-if="$route.params.contentType == 'Senior Management'">
                        <management :contents="contentItem"></management>
                    </div>
                    <div v-else-if="$route.params.contentType == 'Contact Us'">
                        <contact-us :contents="contentItem"></contact-us>
                    </div>
                    <div v-else-if="$route.params.contentType == 'Organization Structure'">
                        <structure :contents="contentItem"></structure>
                    </div>
                    <!-- <div v-else-if="$route.params.contentType === 'Constitution'">
                        <v-row>
                            <v-col cols="1"  class="d-flex align-center pr-0">
                                <v-text-field dense :hide-details="true" outlined type="number" v-model="currentPage"></v-text-field>
                            </v-col>
                            <v-col class="d-flex align-center">
                                <span class="font-weight-bold">/ {{numPages}}</span>
                            </v-col>
                        </v-row>
                        <v-card>
                            <pdf
                            :src="src"
                            @num-pages="pageCount = $event"
                            @page-loaded="currentPage = $event"
                            >
                                <template slot="loading">
                                loading content here...
                                </template>
                            </pdf>
                        </v-card>
                    </div> -->
                    <div v-else>
                        <p class="title" v-if="$route.params.contentType === 'Career opportunities'">Sorry, there are no positions available at this time.</p>
                        <p class="title" v-else>Page Not Found!</p>
                    </div>
                </div>
                
                <v-pagination class="my-5 elevation-0" v-if="totalRows > 20" :total-visible="7" v-model="page" :length="numberOfPages"></v-pagination>
                <highcharts class="mt-5"  v-if="chartAvailability($route.params.contentType)" :options="chartOptions.chartData" ref="summaryChart"></highcharts>
                
            </v-col>
            <v-col cols="1" sm="1">
                <div class="sticky">
                    <v-btn icon class="my-2" @click="printPage()" color="grey lighten-1">
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                    <br>
                    <v-btn :href="`http://www.facebook.com/sharer.php?u=${currentUrl}`" target="_blank" icon class="my-2" color="grey lighten-1">
                        <v-icon>mdi-facebook</v-icon>
                    </v-btn>
                    <br>
                    <v-btn :href="`https://twitter.com/intent/tweet?url=${currentUrl}`" icon class="my-2" target="_blank" color="grey lighten-1">
                        <v-icon>mdi-twitter</v-icon>
                    </v-btn>
                    <br>
                    <v-btn href="mailTo:info@agoffice.gov.mv" icon class="my-2" target="_blank" color="grey lighten-1">
                        <v-icon>mdi-email</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { Chart } from 'highcharts-vue'
import ItemList from '../components/ItemList.vue'
import SingleContent from '../components/SingleContent.vue'
import FormerAttorneys from '../components/FormerAttorneys.vue'
import ContactUs from '../components/ContactUs.vue'
import Management from '../components/Management'
import AgProfile from '../components/AgProfile'
import Colleagues from '../components/Colleagues'
import Visits from '../components/Visits'
import Structure from '../components/Structure'
// import pdf from 'vue-pdf'
// var loadingTask = pdf.createLoadingTask('./files/English-constitution.pdf')
export default {
    name: 'Content',
    props: ['navItems'],
    data: () => ({
        loadingPage: true,
        contentItem: [],
        agProfile: false,
        // src: loadingTask,
        // numPages: undefined,
        currentPage: 1,
        pageCount: 0,
        currentUrl: 'window.location.href',
        totalRows: 0,
        numberOfPages: 0,
        page: 1
    }),
    components: {
        // pdf,
        'item-list': ItemList,
        'single-content': SingleContent,
        'former-attorneys': FormerAttorneys,
        'management' : Management,
        'ag-profile' : AgProfile,
        'colleagues' : Colleagues,
        'visits' : Visits,
        'structure' : Structure,
        'contact-us' : ContactUs,
        highcharts: Chart
    },
    watch: {
        page (val) {
            this.$router.push({query: {page: val}}).catch(()=>{});
            this.getData()
        }
    },
    created() {
        this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
        // this.$activeTab = '$route.params.category'
        this.getData()
        this.$http.get('./Charts.json').then((response) => {
            this.chartOptions = response.data
        })
        // this.src.promise.then(pdf => {
		//     this.numPages = pdf.numPages;
		// })
    },
    methods: {
        getData() {
            this.$http.get(`${this.$url}/pagination/2/${this.$route.params.category}/${this.$route.params.contentType}?limit=21&page=${this.page-1}&sort=${this.$route.params.contentType === 'Former Attorneys General' ? 'id%20desc' : this.$route.params.contentType === 'Meet our Colleagues' ? 'content_order' : 'date%20desc'}`).then((response)=>{
                this.contentItem = response.data.data.rows
                this.totalRows = response.data.data.total_rows
                this.numberOfPages = Math.ceil(response.data.data.total_rows / 21)
                this.loadingPage = false
                if (this.$route.params.category == 'Attorney General' && this.contentItem.length <= 0) {
                    this.$http.get(`${this.$url}/pagination/2/${this.$route.params.category}?limit=20&page=0&title.contains=${this.$route.params.contentType}&sort=id%20desc`).then((response)=>{
                        this.contentItem = response.data.data.rows
                        if (this.contentItem.length > 0) {
                            this.agProfile = true
                        }
                        this.loadingPage = false
                    })
                }
            })
        },
        getImage(item) {
                // console.log('item.Files')
            if (item.Files && item.Files.length > 0) {
                let images = item.Files.filter(obj => obj.FileType.includes('image'))
                if (images.length > 0) {
                return `${this.$url}/downloadfile/${images[0].ID}`
                }
                else {
                return ''
                }
            }
            else {
                return ''
            }
        },
        getReversed(items) {
            return items.reverse()
        },
        printPage() {
            // Get HTML to print from element
            const prtHtml = document.getElementById('printdiv').innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
            }

            // Open the print window
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

            WinPrint.document.write(`<!DOCTYPE html>
            <html>
            <head>
                ${stylesHtml}
            </head>
            <body>
                ${prtHtml}
            </body>
            </html>`);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            WinPrint.close();
            // window.print()
        },
        chartAvailability (page) {
            if (this.chartOptions) {
                return this.chartOptions.pgae === page
            }
        }
    }
}
</script>
<style>
.ql-editor {
    padding: 0
}
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
@media print {
img {
    opacity: 0.3;
    position: absolute;
    left: 2%;
    top: 100px;
}
}
</style>
